import { SUPPORT } from '../actionTypes';

const initialState = {
  content: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUPPORT.SUCCESS:
      return {
        ...state,
        content: action.payload,
      };
    default:
      return state;
  }
};
